import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import { useMemo } from 'react'

const useIsOrderable = (now: Date, orderStartDateTime: Date, lastOrderDateTime: Date): boolean => {
  return useMemo(() => {
    return isAfter(now, orderStartDateTime) && isBefore(now, lastOrderDateTime)
  }, [now, orderStartDateTime, lastOrderDateTime])
}

export default useIsOrderable
